import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { ClipboardServiceInterface } from '../../../../services/clipboard/clipboard-service.interface';
import { IEnvironment } from '../../../../services/environment/environment.interface';

@Component({
  selector: 'gtd-ui-field-special-get-smart-link',
  templateUrl: './get-smart-link.component.html',
  styleUrls: ['./get-smart-link.component.scss'],
})
export class GetSmartLinkComponent {
  @Input() private data: any;
  public link: string;
  private endpointApi: string;
  public isLoading = false;

  constructor(
    private http: HttpClient,
    @Inject('IEnvironmentService') private envService: IEnvironment,
    private cd: ChangeDetectorRef,
    @Inject('ClipboardServiceInterface') private clipboardService: ClipboardServiceInterface
  ) {
    this.endpointApi = this.envService.getVar('services.api') as string;
  }

  getLink() {
    this.isLoading = true;
    const requestParams = {
      widget: 'AffiliateCrm\\SmartLink\\LinkGenerator',
      settings: {
        smart_link_id: this.data,
      },
    };
    this.http.post(`${this.endpointApi}/widget/data`, requestParams).subscribe({
      next: (r: any) => {
        this.isLoading = false;
        this.link = r.data?.link;
        this.cd.detectChanges();
      },
      error: () => {
        this.isLoading = false;
        this.cd.detectChanges();
      }
    });
  }

  copy(): void {
    this.clipboardService.copyFromContent(this.link);
  }
}
